import React, { useState, useContext } from 'react';
import { IRootState } from 'src/reducers';
import { useSelector } from 'react-redux';
import { Url } from 'src/api';
import { useFetch } from 'use-http';
import Card from 'src/components/common/Card.redesign';
import VisibilityLoader from 'src/components/common/VisibilityLoader';
import { ContextMenuAction } from 'src/components/common/ContextMenu';
import Section from 'src/models/Section';
import { DialogContext, dialogCreators } from 'src/providers/DialogProvider';
import { LandSystem } from 'src/models/LandSystem';
// import MathUtil from 'src/util/MathUtil';
// import tagsToString from 'src/components/common/UtilityFunctions';

interface ISectionCardProps {
    sectionNumber: number;
    townshipId: number;
    isActive: boolean;
    handleSectionSelect: (sectionNumber: number) => void;
    landSystem: LandSystem;
    tags?: string;
}

const SectionCard: React.FC<ISectionCardProps> = (props) => {
    const appContext = useSelector((state: IRootState) => state.appContext);
    const dialogContext = useContext<dialogCreators>(DialogContext);
    const [section, setSection] = useState<Section>(undefined);
    // const [sectionAcreage, setSectionAcreage] = useState(undefined);

    const { get, response } = useFetch();

    const loadData = async (isVisible: boolean) => {
        if (isVisible && !section) {
            const sectionCall = get(Url.project.getSection(appContext, props.sectionNumber));
            // const acreageCall = get(Url.project.getSectionAcreage(appContext, props.sectionNumber));

            // const [sectionData, acreageData] = [await sectionCall, await acreageCall];
            const [sectionData] = [await sectionCall];

            if (response.ok) {
                setSection(sectionData);
                // setSectionAcreage(acreageData);
            }
        }
    };

    // const acreage = () => {
    //     let data: React.ReactElement = undefined;
    //     if (!sectionAcreage) {
    //         data = <span>Loading...</span>;
    //     } else {
    //         const grossAcres = MathUtil.cleanNumber(sectionAcreage.grossAcres as number);
    //         const hbpAcres = MathUtil.cleanNumber(sectionAcreage.hbpAcres as number);
    //         const leasedAcres = MathUtil.cleanNumber(sectionAcreage.leasedAcres as number);
    //         const openAcres = MathUtil.cleanNumber(sectionAcreage.openAcres as number);

    //         data = (
    //             <div>
    //                 <div style={{ width: '100%', padding: '1rem 1rem' }}>
    //                     <span 
    //                         style={{ visibility: (section?.tags?.length ? section?.tags?.length : 0) < 1 ? 'hidden' : 'visible',
    //                         fontWeight: 'bold', display: 'inline-block', marginRight: '.6rem', whiteSpace: 'nowrap' }}
    //                     >Tags:
    //                     </span>
    //                     <span>
    //                         {tagsToString(section?.tags)}
    //                     </span>
    //                 </div>
    //             <div
    //                 style={{
    //                     width: '100%',
    //                     height: '100%',
    //                     display: 'flex',
    //                     justifyContent: 'space-evenly',
    //                     fontSize: '.7em',
    //                     background: '#ccc',
    //                     color: '#555',
    //                     fontWeight: 'bold',
    //                 }}
    //             >
    //                 <span style={{ textAlign: 'left', padding: '.2rem .3rem', width: '100%' }}>Gross</span>
    //                 <span style={{ textAlign: 'right', padding: '.2rem .3rem', color: '#6393C1', background: '#f1f1f1', width: '100%' }}>
    //                     {grossAcres}
    //                 </span>
    //                 <span style={{ textAlign: 'left', padding: '.2rem .3rem', width: '100%' }}>HBP</span>
    //                 <span style={{ textAlign: 'right', padding: '.2rem .3rem', color: '#6393C1', background: '#f1f1f1', width: '100%' }}>
    //                     {hbpAcres}
    //                 </span>
    //                 <span style={{ textAlign: 'left', padding: '.2rem .3rem', width: '100%' }}>Open</span>
    //                 <span style={{ textAlign: 'right', padding: '.2rem .3rem', color: '#6393C1', background: '#f1f1f1', width: '100%' }}>
    //                     {openAcres}
    //                 </span>
    //                 <span style={{ textAlign: 'left', padding: '.2rem .3rem', width: '100%' }}>Leased</span>
    //                 <span style={{ textAlign: 'right', padding: '.2rem .3rem', color: '#6393C1', background: '#f1f1f1', width: '100%' }}>
    //                     {leasedAcres}
    //                 </span>
    //             </div>
    //             </div>
    //         );
    //     }

    //     return (
    //         <div className="acreage" style={{ width: '100%', position: 'relative', border: '1px solid #ccc', borderWidth: '1px 0' }}>
    //             <span className="grid">{data}</span>
    //         </div>
    //     );
    // };

    const content = () => {
        let sectionContent: React.ReactElement = undefined;

        if (!section) {
            sectionContent = <div>Loading...</div>;
        } else {
            sectionContent = (
                <>
                    <div style={{ padding: '.4rem', display: 'flex', marginTop: '.5rem' }}>
                        <div className="title" style={{ width: '10rem', fontSize: '.9em' }}>
                            Section {section.sectionNumber}
                        </div>
                        {/* {acreage()} */}
                    </div>
                </>
            );
        }

        return sectionContent;
    };

    const reloadSection = async () => {
        const sectionCall = get(Url.project.getSection(appContext, props.sectionNumber));
        // const acreageCall = get(Url.project.getSectionAcreage(appContext, props.sectionNumber));

        // const [sectionData, acreageData] = [await sectionCall, await acreageCall];
        const [sectionData] = [await sectionCall];

        if (response.ok) {
            setSection(sectionData);
            // setSectionAcreage(acreageData);
        }
    };

    const actions: ContextMenuAction[] = [
        {
            text: 'Modify Section',
            action: () =>
                dialogContext.project.addUpdateDeleteSection(props.townshipId, props.sectionNumber, 'edit', props.landSystem, reloadSection),
        },
    ];

    // const rightBadge = () => {
    //     if (!sectionAcreage) {
    //         return '';
    //     }

    //     return (
    //         <span style={{ fontSize: '.8em', fontWeight: 'bold', color: '#999' }}>
    //             <span>{props.tags !== undefined ? props.tags : []}</span>
    //             <span>{`${sectionAcreage.tractCount} Tract${sectionAcreage.tractCount !== 1 ? 's' : ''}`}</span>
    //             <span style={{ marginLeft: '.5rem' }}>{`${sectionAcreage.ownerCount} Owner${sectionAcreage.ownerCount !== 1 ? 's' : ''}`}</span>
    //         </span>
    //     );
    // };

    const cardStyle: React.CSSProperties = {
        padding: '0 0 .2rem 0',
        position: 'relative',
        minHeight: '2.5rem',
    };

    return (
        <Card
            className={`inner-card ${props.isActive ? 'active' : ''}`}
            contextActions={actions}
            newContext={true}
            showMenu={true}
            onClick={() => props.handleSectionSelect(props.sectionNumber)}
            badge={`${section?.dlcNumber || ''}`}
            // rightBadgePanel={rightBadge()}
        >
            <VisibilityLoader onVisibilityChanged={loadData}>
                <div style={cardStyle}>{content()}</div>
            </VisibilityLoader>
        </Card>
    );
};

export default SectionCard;



// WEBPACK FOOTER //
// ./src/components/project/sections/tract/components/SectionCard.tsx